import * as Yup from 'yup';
import { passwordValidation } from './password.validation';

export const changePasswordValidationSchema = Yup.object({
  password: passwordValidation,
  confirmPassword: Yup.string().oneOf([Yup.ref('password'), undefined], 'Passwords must match'),
});
